import { render, staticRenderFns } from "./filter-popover.vue?vue&type=template&id=36719610&lang=pug"
import script from "./filter-popover.vue?vue&type=script&lang=ts"
export * from "./filter-popover.vue?vue&type=script&lang=ts"
import style0 from "./filter-popover.vue?vue&type=style&index=0&id=36719610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports